module.exports = __webpack_public_path__ + "assets/img/thumb-AuditCover.e3d33bdd.jpg";